import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { addAlert, useMaterialUIController } from "context";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LayoutType, QuestionType, ResponseType } from "models/batch/Question";
import { Grid } from "@mui/material";
import { EnumAutocomplete } from "components/alove/EnumAutocomplete";
import { createQuestion } from "utils/questionsUtils";

const MDInput = require("components/MDInput").default;

export const AddQuestionDialog = ({ questionaireID, afterCreate }: { questionaireID: number, afterCreate?: () => void }) => {
  const [controller, dispatch] = useMaterialUIController();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    text: "",
    questionType: QuestionType.Bio,
    responseType: ResponseType.Text,
    layout: LayoutType.InChat
  });

  const handleConfirm = async () => {
    createQuestion({
      text: formData.text,
      questionType: formData.questionType,
      responseType: formData.responseType,
      layout: formData.layout,
      batchId: questionaireID
    });
    afterCreate?.();
  };

  return (
    <AloveDialog
      dialogType={DialogType.AddQuestionnaire}
      dialogTitle="Add New Question"
      dialogBody="Enter the details for your new question"
      dialogConfirm="Create"
      valid={formData.text.length > 0}
      handleConfirm={handleConfirm}
    >
      <Grid container spacing={2}>
        <Grid size={12}>
          <MDInput
            fullWidth
            label="Question Name"
            placeholder="Enter question name"
            required
            value={formData.text}
                onChange={(e) => setFormData({ ...formData, text: e.target.value })}
          />
        </Grid>
        <Grid size={12}>
          <EnumAutocomplete
            enumName={ResponseType}
            value={formData.responseType}
            onChange={(value) => setFormData({ ...formData, responseType: value })}
          />
        </Grid>
        <Grid size={6}>
          <EnumAutocomplete
            enumName={QuestionType}
            value={formData.questionType}
            onChange={(value) => setFormData({ ...formData, questionType: value })}
          />
        </Grid>
        <Grid size={6}>
          <EnumAutocomplete
            enumName={LayoutType}
            value={formData.layout}
            onChange={(value) => setFormData({ ...formData, layout: value })}
          />
        </Grid>
      </Grid>
    </AloveDialog>
  );
}; 